<template>
	<base-user-form
		add-user-function="addLogistic"
		link-back="logistics-list"
		new-title="Nový logistik"
		title="Logistik" />
</template>

<script>
import FormMixin from '@/util/form-mixin';
import { BaseUserForm } from '@/components/Base';

export default {
	name: 'LogisticsForm',
	components: { BaseUserForm },
	mixins: [FormMixin],
};
</script>
